import ic_aitv from "./icons/ic_aitv.svg";
import img_arrow_point from "./images/img_arrow_point.png";
import img_books from "./images/img_books.png";
import img_pulp from "./images/img_pulp.png";
import img_smile_chat from "./images/img_smile_chat.png";
import ic_mic from "./icons/ic_mic.svg";
import ic_upload_btn from "./icons/ic_upload_btn.svg";
import ic_upload_btn_1 from "./icons/ic_upload_btn_1.svg";
import ic_rose_star from "./icons/ic_rose_star.svg";
import ic_golden_star from "./icons/ic_golden_star.svg";
import ic_chat_moniter from "./icons/ic_chat_moniter.svg";
import ic_chat_person from "./icons/ic_chat_person.svg";
import ic_message_box from "./icons/ic_message_box.svg";
import ic_home from "./icons/ic_home.svg";
import ic_nav_burger from "./icons/ic_nav_burger.svg";
import ic_nav_logo from "./icons/ic_nav_logo.svg";
import ic_nav_moniter from "./icons/ic_nav_moniter.svg";
import ic_video from "./icons/ic_video.svg";
import ic_active_home from "./icons/ic_active_home.svg";
import ic_active_burger from "./icons/ic_active_burger.svg";
import ic_active_dashboard_burger from "./icons/ic_active_dashboard_burger.svg";
import ic_active_mointer from "./icons/ic_active_mointer.svg";
import ic_active_dashboard_moniter from "./icons/ic_active_dashboard_moniter.svg";
import ic_logout from "./icons/ic_logout.svg";
import ic_chevron_down from "./icons/ic_chevron_down.svg";
import ic_profile_moniter from "./icons/ic_profile_moniter.svg";
import ic_refresh from "./icons/ic_refresh.svg";
import ic_maximize from "./icons/ic_maximize.svg";
import ic_print from "./icons/ic_print.svg";
import ic_burgur_dot from "./icons/ic_burgur_dot.svg";
import ic_password_box from "./icons/ic_password_box.svg";
import ic_mail_box from "./icons/ic_mail_box.svg";
import ic_login_img from "./icons/ic_login_img.svg";
import ic_uncheckbox from "./icons/ic_uncheckbox.svg";
import ic_history from "./icons/ic_history.svg";
import ic_timer from "./icons/ic_timer.svg";
import ic_sign_arrow from "./icons/ic_sign_arrow.svg";
import ic_heart from "./icons/ic_heart.svg";
import ic_login_graudate_white from "./icons/ic_login_graudate_white.svg";
import ic_graudate from "./icons/ic_graudate.svg";
import img_arch_bottom from "./images/img_arch_bottom.png";
import img_arch_top from "./images/img_arch_top.png";
import ic_student_manage from "./icons/ic_student_manage.svg";
import ic_school_manage from "./icons/ic_school_manage.svg";
import img_student_going_to_school from "./images/student_going_to_school.svg";
import img_digital_nomad from "./images/digital_nomad.svg";
import ic_active_student_manage from "./icons/ic_active_student_manage.svg";
import ic_active_school_manage from "./icons/ic_active_school_manage.svg";
import ic_delete_record from "./icons/ic_delete_record.svg";
import ic_download_arrow from "./icons/ic_download_arrow.svg";
import ic_download_btn from "./icons/ic_download_btn.svg";
import ic_edit from "./icons/ic_edit.svg";
import ic_notification_bell from "./icons/ic_notification_bell.svg";
import ic_persons from "./icons/ic_persons.svg";
import ic_refetch from "./icons/ic_refetch.svg";
import ic_search from "./icons/ic_search.svg";
import ic_settings from "./icons/ic_settings.svg";
import ic_unactivity_person from "./icons/ic_unactivity_person.svg";
import ic_activity_person from "./icons/ic_activity_person.svg";
import ic_notify_bell from "./icons/ic_notify_bell.svg";
import ic_close from "./icons/ic_close.svg";
import ic_unattempt from "./icons/ic_unattempt.svg";
import ic_score from "./icons/ic_score.svg";
import ic_wrong from "./icons/ic_wrong.svg";
import ic_correct from "./icons/ic_correct.svg";
import ic_correct_tick from "./icons/ic_correct_tick.svg";
import ic_close_wrong from "./icons/ic_close_wrong.svg";
import ic_info from "./icons/ic_info.svg";
import ic_retake from "./icons/ic_retake.svg";
import ic_award from "./icons/ic_award.svg";
import ic_closed_eye from "./icons/ic_closed_eye.svg";
import ic_eye from "./icons/ic_eye.svg";
import ic_checkbox_tick from "./icons/ic_checkbox_tick.svg";
import ic_logoutimg from "./icons/ic_logoutimg.svg";
import ic_back_arrow from "./icons/ic_back_arrow.svg";
import ic_statics from "./icons/ic_statics.svg";
import ic_info_outline from "./icons/ic_info_outline.svg";
import img_ai_genertor from "./images/img_ai_genertor.png";
import ic_select_subject from "./icons/ic_select_subject.svg";
import ic_subject_delete from "./icons/ic_subject_delete.svg";
import ic_add from "./icons/ic_add.svg";
import ic_book from "./icons/ic_book.svg";
import ic_plub from "./icons/ic_plub.svg";
import ic_alert from "./icons/ic_alert.svg";
import ic_right_arrow from "./icons/ic_right_arrow.svg";
import ic_close_white from "./icons/ic_close_white.svg";
import ic_add_white from "./icons/ic_add_white.svg";
import ic_generate_magic from "./icons/ic_generate_magic.svg";
import ic_timer_blue from "./icons/ic_timer_blue.svg";
import ic_refresh_blue from "./icons/ic_refresh_blue.svg";
import ic_lightbulb from "./icons/ic_lightbulb.svg";
import ic_lightbulb_white from "./icons/ic_lightbulb_white.svg";
import ic_success_tick from "./icons/ic_success_tick.svg";
import ic_failure_tick from "./icons/ic_failure_tick.svg";
import ic_magic_logo from "./icons/ic_magic_logo.svg";
import img_bg from "./images/img_bg.png";
import ic_play from "./icons/ic_play.svg";
import ic_video_bg from "./icons/ic_video_bg.svg";
import ic_audio from "./icons/ic_audio.svg";
import ic_active_files from "./icons/ic_active_files.svg";
import ic_files from "./icons/ic_files.svg";
import ic_timer_blue_outlet from "./icons/ic_timer_blue_outlet.svg";
import ic_gray_tick from "./icons/ic_gray_tick.svg";
import ic_active_video from "./icons/ic_active_video.svg";
import ic_active_dashboard_video from "./icons/ic_active_dashboard_video.svg";
import ic_jee from "./icons/ic_jee.svg";
import ic_logout_red from "./icons/ic_logout_red.svg";
import ic_change_pwd from "./icons/ic_change_pwd.svg";
import ic_refresh_red from "./icons/ic_refresh_red.svg";
import ic_wrong_close from "./icons/ic_wrong_close.svg";
import ic_youtube from "./icons/ic_youtube.svg";
import ic_volume_green from "./icons/ic_volume_green.svg";
import ic_active_award from "./icons/ic_active_award.svg";
import ic_reward from "./icons/ic_reward.svg";
import ic_neet from "./icons/ic_neet.svg";
import ic_upse from "./icons/ic_upse.svg";
import ic_ssc from "./icons/ic_ssc.svg";
import ic_bank from "./icons/ic_bank.svg";
import ic_cat from "./icons/ic_cat.svg";
import ic_clat from "./icons/ic_clat.svg";
import ic_nda from "./icons/ic_nda.svg";
import ic_gate from "./icons/ic_gate.svg";
import ic_psc from "./icons/ic_psc.svg";
import ic_railway from "./icons/ic_railway.svg";
import ic_cuet from "./icons/ic_cuet.svg";
import ic_audio_bg from "./icons/ic_audio_bg.svg";
import ic_tick_white from "./icons/ic_tick_white.svg";
import ic_descriptive from "./icons/ic_descriptive.svg";
import ic_active_descriptive from "./icons/ic_active_descriptive.svg";
import ic_active_dashboard_descriptive from "./icons/ic_active_dashboard_descriptive.svg";
import ic_quest from "./icons/ic_quest.svg";
import ic_desc_test from "./icons/ic_desc_test.svg";
import ic_progress from "./icons/ic_progress.svg";
import ic_warning from "./icons/ic_warning.svg";
import ic_more from "./icons/ic_more.svg";
import ic_info_back from "./icons/ic_info_back.svg";
import ic_time from "./icons/ic_time.svg";
import ic_language from "./icons/ic_language.svg";
import ic_video_blue from "./icons/ic_video_blue.svg";
import ic_left_arrow_blue from "./icons/ic_left_arrow_blue.svg";
import ic_arrow_white from "./icons/ic_arrow_white.svg";
import ic_add_circle from "./icons/ic_add_circle.svg";
import ic_right_arrow_white from "./icons/ic_right_arrow_white.svg";
import ic_graph from "./icons/ic_graph.svg";
import ic_pencil from "./icons/ic_pencil.svg";
import ic_book_voilet from "./icons/ic_book_voilet.svg";
import ic_graudate_color from "./icons/ic_graudate_color.svg";
import ic_calculator from "./icons/ic_calculator.svg";
import ic_robot_box from "./icons/ic_robot_box.svg";
import ic_star from "./icons/ic_star.svg";
import ic_message_white_box from "./icons/ic_message_white_box.svg";
import ic_new_orange from "./icons/ic_new_orange.svg";
import ic_copy from "./icons/ic_copy.svg";
import ic_mood_emoji from "./icons/ic_mood_emoji.svg";
import ic_join_rocket from "./icons/ic_join_rocket.svg";
import ic_wifi_green from "./icons/ic_wifi_green.png";
import ic_quick_tip from "./icons/ic_quick_tip.png";
import ic_fair_play from "./icons/ic_fair_play.svg";
import ic_file_grey from "./icons/ic_file_grey.svg";
import ic_timer_grey from "./icons/ic_timer_grey.svg";
import ic_calendar_grey from "./icons/ic_calendar_grey.svg";
import ic_pencil_blue from "./icons/ic_pencil_blue.svg";
import ic_plub_brown from "./icons/ic_plub_brown.svg";
import ic_wining_trophy from "./icons/ic_wining_trophy.svg";
import ic_chats_avatar from "./icons/ic_chats_avatar.svg";
import ic_deadline from "./icons/ic_deadline.svg";
import ic_practice_mcq from "./icons/ic_practice_mcq.png";
import ic_join_room_mcq from "./icons/ic_join_room_mcq.png";
import ic_leave_orange from "./icons/ic_leave_orange.png";
import ic_cancel from "./icons/ic_cancel.svg";
import ic_scores from "./icons/ic_scores.svg";
import ic_joined from "./icons/ic_joined.svg";
import ic_submitted from "./icons/ic_submitted.svg";
import ic_tnstate_board from "./icons/ic_tnstate_board.svg";
import ic_icse from "./icons/ic_icse.svg";
import ic_caie from "./icons/ic_caie.svg";
import ic_profile_chat from "./icons/ic_profile_chat.svg";
import ic_cbse from "./icons/ic_cbse.svg";
import ic_practice from "./icons/ic_practice.svg";
import ic_competitive from "./icons/ic_competitive.svg";
import ic_fullscreen from "./icons/ic_fullscreen.svg";
import ic_dashboard from "./icons/ic_dashboard.svg";
import ic_performance from "./icons/ic_performance.svg";
import ic_test from "./icons/ic_test.svg";
import ic_frame from "./icons/Frame.svg";
import ic_leaderboard from "./icons/ic_leaderboard.svg";
import ic_question from "./icons/ic_question.svg";
import ic_knowledge from "./icons/ic_knowledge.svg";
import ic_active_dashboard from "./icons/ic_active_dashboard.svg";
import ic_active_performance from "./icons/ic_active_performance.svg";
import ic_active_test from "./icons/ic_active_test.svg";
import ic_active_leaderboard from "./icons/ic_active_leaderboard.svg";
import ic_active_question from "./icons/ic_active_question.svg";
import ic_active_knowledge from "./icons/ic_active_knowledge.svg";
import ic_calendar from "./icons/ic_calendar.svg";
import ic_notify_active from "./icons/ic_notify_active.svg";
import ic_logo from "./icons/ic_logo.svg";
import ic_attempts from "./icons/ic_attempts.svg";
import ic_learning_status from "./icons/ic_learning_status.svg";
import ic_conversation from "./icons/ic_conversation.svg";
import ic_writing from "./icons/ic_writing.svg";
import ic_reading from "./icons/ic_reading.svg";
import ic_read from "./icons/ic_read.svg";
import ic_text from "./icons/ic_text.svg";
import ic_grammar from "./icons/ic_grammar.svg";
import ic_strength from "./icons/ic_strength.svg";
import ic_improve from "./icons/ic_improve.svg";
import ic_recommend from "./icons/ic_recommend.svg";
import ic_excellent from "./icons/ic_excellent.svg";
import ic_grammar_green from "./icons/ic_grammar_green.svg";
import ic_mic_white from "./icons/ic_mic_white.svg";
import ic_student_orange from "./icons/ic_student_orange.svg";
import ic_test_attend from "./icons/ic_test_attend.svg";
import ic_average_score from "./icons/ic_average_score.svg";
import ic_question_blue from "./icons/ic_question_blue.svg";
import ic_question_grey from "./icons/ic_question_grey.svg";
import ic_leader_yellow from "./icons/ic_leader_yellow.svg";
import ic_knowledge_pink from "./icons/ic_knowledge_pink.svg";
import ic_manage_test from "./icons/ic_manage_tests.svg";
import ic_total_student from "./icons/ic_total_student.svg";
import ic_arrow_blue from "./icons/ic_arrow_blue.svg";
import ic_logout_grey from "./icons/ic_logout_grey.svg";
import ic_upload from "./icons/ic_upload.svg";
import ic_pdf_purple from "./icons/ic_pdf_purple.svg";
import ic_active_question_bank from "./icons/ic_active_question_bank.svg";

import img_rovian_logo from "./images/img_rovian_logo.png";
import ic_payicon from "./icons/ic_payicon.png";
import ic_learning_container from "./icons/ic_learning_container.jpeg";
import ic_vocabulary from "./icons/ic_vocabulary.svg";
import ic_words from "./icons/ic_words.svg";
import ic_magic_green from "./icons/ic_magic_green.svg";
import ic_test_attented from "./icons/ic_test_attented.svg";
import ic_overall from "./icons/ic_overall.svg";
import ic_average from "./icons/ic_average.svg";
import ic_search_white from "./icons/ic_search_white.svg";
import ic_async from "./icons/ic_async.svg";
import ic_live from "./icons/ic_live.svg";
import ic_live_test_white from "./icons/ic_live_test_white.svg";
import ic_live_test_grey from "./icons/ic_live_test_grey.svg";
import ic_time_white from "./icons/ic_time_white.svg";
import ic_async_status from "./icons/ic_async_status.svg";
import ic_live_status from "./icons/ic_live_status.svg";
import ic_send from "./icons/ic_send.svg";
import ic_circle_checked from "./icons/ic_circle_checked.svg";
import ic_circle_timer from "./icons/ic_circle_timer.svg";
import ic_circle_play from "./icons/ic_circle_play.svg";
import ic_white_tick from "./icons/ic_white_tick.svg";
import ic_green_circle_tick from "./icons/ic_green_circle_tick.svg";
import ic_calender_green from "./icons/ic_calender_green.svg";
import ic_calender_violet from "./icons/ic_calender_violet.svg";
import ic_calender_yellow from "./icons/ic_calender_yellow.svg";
import ic_calender_orange from "./icons/ic_calender_orange.svg";
import ic_fire_orange from "./icons/ic_fire_orange.svg";
import ic_graph_blue from "./icons/ic_graph_blue.svg";
import ic_video_blue_circle from "./icons/ic_video_blue_circle.svg";
import ic_price_dark_red from "./icons/ic_price_dark_red.svg";
import ic_note_green from "./icons/ic_note_green.svg";
import ic_book_blue from "./icons/ic_book_blue.svg";
import ic_success_tick_round from "./icons/ic_success_tick_round.svg";
import ic_info_success from "./icons/ic_info_success.svg";
import ic_unlock_limit from "./icons/ic_unlock_limit.svg";
import ic_check_mail from "./icons/ic_check_mail.svg";
import img_Khan_Academy_logo from "./images/img_Khan_Academy_logo.png";
import img_robot from "./images/img_robot.png";
import ic_check_green from "./icons/ic_check_green.svg";
import ic_filter from "./icons/ic_filter.svg";
import ic_refetch_blue from "./icons/ic_refetch_blue.svg";

// import ic_book_voilet_outline from "./icons/ic_book_voilet_outline.svg";

const assets = {
  img_robot,
  ic_check_green,
  img_Khan_Academy_logo,
  ic_message_box,
  ic_async_status,
  ic_live_status,
  ic_live_test_white,
  ic_live_test_grey,
  ic_time_white,
  ic_async,
  ic_live,
  ic_vocabulary,
  ic_words,
  ic_deadline,
  ic_scores,
  ic_joined,
  ic_deadline,
  ic_submitted,
  ic_cancel,
  ic_copy,
  ic_new_orange,
  ic_message_white_box,
  ic_star,
  ic_robot_box,
  ic_book_voilet,
  ic_pencil,
  ic_graudate_color,
  ic_calculator,
  ic_graph,
  ic_delete_record,
  ic_add_circle,
  ic_more,
  ic_warning,
  ic_progress,
  ic_desc_test,
  ic_quest,
  ic_descriptive,
  ic_practice,
  ic_active_descriptive,
  ic_active_dashboard_descriptive,
  ic_refresh_red,
  ic_video_bg,
  ic_change_pwd,
  ic_logout_red,
  ic_audio,
  ic_audio_bg,
  img_bg,
  ic_jee,
  ic_history,
  ic_play,
  ic_back_arrow,
  ic_statics,
  ic_download_arrow,
  ic_download_btn,
  ic_edit,
  ic_notification_bell,
  ic_search,
  ic_settings,
  ic_activity_person,
  ic_unactivity_person,
  ic_notify_bell,
  ic_persons,
  ic_refetch,
  ic_student_manage,
  ic_school_manage,
  ic_active_student_manage,
  ic_active_school_manage,
  ic_aitv,
  img_arrow_point,
  img_books,
  ic_timer,
  img_pulp,
  ic_mic,
  ic_upload_btn,
  ic_upload_btn_1,
  img_smile_chat,
  ic_golden_star,
  ic_rose_star,
  ic_chat_moniter,
  ic_chat_person,
  ic_message_box,
  ic_video,
  ic_nav_moniter,
  ic_nav_logo,
  ic_nav_burger,
  ic_home,
  ic_active_mointer,
  ic_active_dashboard_moniter,
  ic_active_burger,
  ic_active_dashboard_burger,
  ic_active_home,
  ic_logout,
  ic_chevron_down,
  ic_burgur_dot,
  ic_print,
  ic_maximize,
  ic_refresh,
  ic_mail_box,
  ic_password_box,
  ic_profile_moniter,
  ic_login_img,
  ic_sign_arrow,
  ic_uncheckbox,
  ic_heart,
  ic_login_graudate_white,
  ic_graudate,
  ic_close,
  ic_pencil,
  ic_correct,
  ic_wrong,
  ic_score,
  ic_unattempt,
  ic_correct_tick,
  ic_close_wrong,
  ic_info,
  ic_retake,
  ic_award,
  ic_closed_eye,
  ic_eye,
  ic_checkbox_tick,
  ic_logoutimg,
  ic_info_outline,
  ic_select_subject,
  ic_subject_delete,
  ic_add,
  ic_book,
  ic_plub,
  ic_alert,
  ic_right_arrow,
  ic_close_white,
  ic_add_white,
  ic_timer_blue,
  ic_generate_magic,
  ic_refresh_blue,
  ic_lightbulb,
  ic_lightbulb_white,
  ic_failure_tick,
  ic_success_tick,
  ic_magic_logo,
  ic_active_files,
  ic_files,
  ic_timer_blue_outlet,
  ic_gray_tick,
  ic_active_video,
  ic_active_dashboard_video,
  ic_wrong_close,
  ic_volume_green,
  ic_youtube,
  ic_active_award,
  ic_reward,
  ic_neet,
  ic_upse,
  ic_ssc,
  ic_bank,
  ic_cat,
  ic_clat,
  ic_nda,
  ic_gate,
  ic_psc,
  ic_railway,
  ic_cuet,
  ic_tick_white,
  ic_info_back,
  ic_time,
  ic_video_blue,
  ic_language,
  ic_left_arrow_blue,
  ic_arrow_white,
  ic_right_arrow_white,
  ic_mood_emoji,
  ic_join_rocket,
  ic_wifi_green,
  ic_quick_tip,
  ic_fair_play,
  ic_timer_grey,
  ic_file_grey,
  ic_calendar_grey,
  ic_pencil_blue,
  ic_plub_brown,
  ic_wining_trophy,
  // ic_book_voilet_outline,
  ic_chats_avatar,
  ic_practice_mcq,
  ic_join_room_mcq,
  ic_leave_orange,
  ic_tnstate_board,
  ic_caie,
  ic_icse,
  ic_profile_chat,
  ic_cbse,
  ic_payicon,
  ic_learning_container,
  ic_competitive,
  ic_fullscreen,
  ic_dashboard,
  ic_performance,
  ic_test,
  ic_leaderboard,
  ic_question,
  ic_knowledge,
  ic_active_dashboard,
  ic_active_performance,
  ic_active_test,
  ic_frame,
  ic_active_leaderboard,
  ic_active_question,
  ic_active_question_bank,
  ic_active_knowledge,
  ic_calendar,
  ic_notify_active,
  ic_logo,
  ic_magic_green,
  ic_attempts,
  ic_learning_status,
  ic_conversation,
  ic_writing,
  ic_reading,
  ic_read,
  ic_text,
  ic_grammar,
  ic_strength,
  ic_improve,
  ic_recommend,
  ic_excellent,
  ic_grammar_green,
  ic_mic_white,
  ic_test_attented,
  ic_overall,
  ic_average,
  ic_search_white,
  ic_send,
  ic_student_orange,
  ic_total_student,
  ic_average_score,
  ic_knowledge_pink,
  ic_arrow_blue,
  ic_logout_grey,
  ic_question_blue,
  ic_question_grey,
  ic_leader_yellow,
  ic_manage_test,
  ic_test_attend,
  ic_circle_play,
  ic_circle_timer,
  ic_circle_checked,
  ic_white_tick,
  ic_green_circle_tick,
  ic_upload,
  ic_pdf_purple,
  ic_calender_green,
  ic_calender_orange,
  ic_calender_violet,
  ic_calender_yellow,
  ic_fire_orange,
  ic_graph_blue,
  ic_video_blue_circle,
  ic_price_dark_red,
  ic_book_blue,
  ic_note_green,
  ic_success_tick_round,
  ic_info_success,
  ic_unlock_limit,
  ic_check_mail,
  ic_filter,
  ic_refetch_blue,

  img_rovian_logo,
  img_arch_bottom,
  img_arch_top,
  img_ai_genertor,
  img_student_going_to_school,
  img_digital_nomad,
};

export default assets;
